import React, { useEffect, useState, useRef } from "react";
import DynamicTable from "../DynamicTable";

const SectionSix = (props) => {
    const { handleButtonClick, setSelectedOptions, selectedOptions, toggleOption, setMessageBoard, setErrorTabEnable, setWorkOrderTab ,data ,showMaximumChat } = props

    const [onClickYes, setOnClickYes] = useState(false);
    const [onClickNo, setOnClickNo] = useState(false);

    const isYesStepValid = (data?.step_6_yes_next_steps || '' ).toLowerCase() !== 'no';
    const isNoStepValid = (data?.step_6_no_next_steps || '').toLowerCase() !== 'no';


    // useEffect(()=>{
    //     if (onClickNo && data?.step_6_no_text?.toLowerCase() === "nan") {
    //         props?.addMessages("Work Order", 10);
    //     }
    // }, [onClickNo, onClickYes])

    // useEffect(()=>{

    //     if(onClickYes && data?.step_6_yes_call_logs){
    //         localStorage.setItem(
    //             "troubleShooting",
    //             JSON.stringify({ key1: data?.step_6_yes_call_logs })
    //           );
    //     }
    //     if(isNoStepValid && data?.step_6_no_call_logs ){
    //         localStorage.setItem(
    //             "troubleShooting",
    //             JSON.stringify({ key1: data?.step_6_no_call_logs })
    //           );
    //     }
    // })

    return (
        <>
            <div className="error-message-head1" style={{fontSize : showMaximumChat && '16px'}} >{data?.step_6_title}</div>
            <div className="error-message-head2" style={{fontSize : showMaximumChat && '16px'}} dangerouslySetInnerHTML={{ __html: data?.step_6_desc}}>
            </div>
            <div style={{ gap: "8px", display: "flex", marginTop: "22px" }}>
                <button
                    onClick={() => {
                        localStorage.setItem(
                            "troubleShooting",
                            JSON.stringify({ key1: data?.step_6_yes_call_logs })
                          );
                        handleButtonClick(6, "yes" ,{section : 'six',value:isYesStepValid});
                        setOnClickYes(true);
                        setOnClickNo(false);
                          // Update selectedOptions based on `step_1_yes_text`
                        if (isYesStepValid) {
                            setSelectedOptions([true, true, true, true, true, true, true]);
                        } else{
                            setSelectedOptions([true, true, true, true, true, true, false]);
                        }
                    }}
                    className={`option-button ${toggleOption[6] === "yes" ? "clicked" : ""
                        }`}
                    
                >
                    Yes
                </button>
                <button
                    onClick={() => {
                        if(isNoStepValid && data?.step_6_no_call_logs ){
                            localStorage.setItem(
                                "troubleShooting",
                                JSON.stringify({ key1: data?.step_6_no_call_logs })
                              );
                        }
                        handleButtonClick(6, "no",{section : 'six',value:isNoStepValid});
                        setOnClickYes(false);
                        setOnClickNo(true);
                        if (isNoStepValid) {
                            setSelectedOptions([true, true, true, true, true, true, true]);
                        } else{
                            setSelectedOptions([true, true, true, true, true, true, false]);
                        }
                    }}
                    className={`option-button ${toggleOption[6] === "no" ? "clicked" : ""
                        }`}
                    
                >
                    No
                </button>
            </div>
            {onClickYes && <div className="error-message-head2" style={{fontSize : showMaximumChat && '16px'}} dangerouslySetInnerHTML={{ __html: data?.step_6_yes_text}}></div>}
            {onClickNo && data?.step_6_no_text?.toLowerCase() !== "nan" && <div className="error-message-head2" style={{fontSize : showMaximumChat && '16px'}} dangerouslySetInnerHTML={{ __html: data?.step_6_no_text}}></div>}
            {/* <div style={{ fontSize: "12px" }} className="error-message-head2">
                If issue persists - Raise FR WO
            </div>
            <div className="error-message-head1">Call Logs</div>
            <button
                onClick={() => {
                    setWorkOrderTab(true);
                    setErrorTabEnable(false);
                }}
                style={{
                    background: "#D02F92",
                    border: "1px solid white",
                    borderRadius: "5px",
                    color: "white",
                    width: "40%",
                    fontSize: "12px",
                    cursor: "pointer",
                    height: "4vh",
                    marginTop: "12px",
                }}
            >
                Create Work Order
            </button> */}

            {/* <div className="error-message-head2">
    Request subscriber to perform reconnection procedure (switch off power supply, wait for 10 seconds and then switch on the power supply)
    </div> */}
         {onClickYes && data?.step_6_yes_call_logs && <DynamicTable data={data?.step_6_yes_call_logs} /> }
         {onClickNo && data?.step_6_no_call_logs && <DynamicTable data={data?.step_6_no_call_logs} /> }
        </>
    )
}

export default SectionSix
